import { Telemetry, ValidTelemetryEvent } from '~commonInfra/services/Telemetry';

enum DMAwarenessTelemetryEvents {
    DMAwarenessInExplore = 'dm_awareness_in_explore'
}

export enum DMAwarenessInExploreActions{
    ViewDMAwarenessFeature='ViewedDMAwarenessFeature',
    LearnMoreAction='ClickedLearnMore',
    HideAction='ClickedHide'
}

export enum DMAwarenessInExploreActionPlaces{
    DQW='dqw',
    Lineage='lineage'
}

interface DMAwarenessInExploreEvent extends ValidTelemetryEvent {
    type: DMAwarenessTelemetryEvents.DMAwarenessInExplore;
    action_type: DMAwarenessInExploreActions;
    action_place: DMAwarenessInExploreActionPlaces;
}

export function sendDMAwarenessTelemetry(actionType: DMAwarenessInExploreActions,actionPlace: DMAwarenessInExploreActionPlaces) {
  Telemetry.sendEvent<DMAwarenessInExploreEvent>({
    type: DMAwarenessTelemetryEvents.DMAwarenessInExplore,
    action_type: actionType,
    action_place: actionPlace
  });
}
